var path = 'areas/shared/views/redirect.html';
var html = "<div class=container-fluid> <div class=row> <div class=\"col-sm-12 col-md-12 col-lg-12\"> <loading-wrapper busy=isLoading> <error-box error=isLoading.error></error-box> </loading-wrapper> </div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/redirect.html
// module id = 973
// module chunks = 1